var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.97674C8.65053 5.97674 5.97674 8.67403 5.97674 12C5.97674 12.2697 5.75809 12.4884 5.48837 12.4884C5.21865 12.4884 5 12.2697 5 12C5 8.13714 8.10854 5 12 5C14.3166 5 16.0514 5.96763 17.1974 6.92359C17.5174 7.19052 17.7926 7.45739 18.0233 7.70364V5.85302C18.0233 5.5833 18.2419 5.36465 18.5116 5.36465C18.7813 5.36465 19 5.5833 19 5.85302V9.10884C19 9.37856 18.7813 9.59721 18.5116 9.59721H15.6205C15.3507 9.59721 15.1321 9.37856 15.1321 9.10884C15.1321 8.83912 15.3507 8.62047 15.6205 8.62047H17.5344C17.2914 8.33877 16.9703 8.00613 16.5717 7.67362C15.5476 6.81935 14.0266 5.97674 12 5.97674ZM18.5116 11.5116C18.7813 11.5116 19 11.7303 19 12C19 15.8641 15.8641 19 12 19C10.0332 19 8.47362 18.0101 7.42957 17.0631C7.15244 16.8118 6.90853 16.5607 6.69953 16.3273V18.147C6.69953 18.4167 6.48088 18.6353 6.21116 18.6353C5.94144 18.6353 5.72279 18.4167 5.72279 18.147V14.8912C5.72279 14.6214 5.94144 14.4028 6.21116 14.4028H9.15442C9.42414 14.4028 9.64279 14.6214 9.64279 14.8912C9.64279 15.1609 9.42414 15.3795 9.15442 15.3795H7.173C7.40793 15.6651 7.71432 16.0027 8.08578 16.3397C9.03754 17.2029 10.3724 18.0233 12 18.0233C15.3247 18.0233 18.0233 15.3247 18.0233 12C18.0233 11.7303 18.2419 11.5116 18.5116 11.5116Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.08ef4aa3.svg";
export { ForwardRef as ReactComponent };